export default __webpack_public_path__ + "static/char-62-333a41e2ac4182192e45d6b06594c77a.webp";